import type { BasicHeadingProps } from './types';
import loadable from '@loadable/component';
import { useFlag } from '@/features/unleash';

const OldBasicHeading = loadable(() => import('./OldBasicHeading'), {
  resolveComponent: (component) => component.BasicHeading,
});

const NewBasicHeading = loadable(() => import('./components/NewBasicHeading'), {
  resolveComponent: (component) => component.BasicHeading,
});

export const BasicHeading = (props: BasicHeadingProps) => {
  const featureFlag = useFlag({ name: 'mono-investing-idea-redesign' });
  const isRedesignEnabled =
    featureFlag.flagsReady &&
    featureFlag.enabled &&
    featureFlag.variant.name === 'variant';

  if (isRedesignEnabled) {
    return <NewBasicHeading {...props} />;
  }

  return <OldBasicHeading {...props} />;
};
